import { FormBase } from "../util/form-base-form";
import { Roles } from "../constants/roles";

export class ExportPostsReviewToggleForm extends FormBase {
    private root: HTMLElement;

    public constructor(root: HTMLElement) {
        super();
        this.root = root;
    }

    public getBoardIdSelect(): HTMLSelectElement | null {
        return this.queryElement(
            this.root,
            `[data-role="${Roles.EXPORT_POSTS_BOARD_ID_SELECT}"]`,
            HTMLSelectElement,
        );
    }

    public getReviewQuestionsField(): HTMLElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.EXPORT_POSTS_REVIEW_QUESTIONS_FIELD}"]`);
    }
}
